import script from "./StudentInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentInformation.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/application-info/info-tile.css?vue&type=style&index=0&id=1a8da089&scoped=true&lang=css"
import "./StudentInformation.vue?vue&type=style&index=1&id=1a8da089&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a8da089"]])

export default __exports__